<template>
  <modal name="roxx-dialog" id="roxx-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div>
      <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
        <el-button @click="closeDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
          type="text"></el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            もうすぐで完了するよ！
          </p>
          <p style="font-size: 120%;">
            今作成した履歴書をもとに<br />
            プロが好条件の勤め先をご紹介します！
          </p>
          <br>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/roxx_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <br />
          <p style="font-size: 140%;">
            ご同意いただいた方には追って連絡がいきますので、ご確認お願いいたします！
          </p>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a>
            <br />
            キャリアシの<a href="https://careerassist.jp/terms/" target="_blank">利用規約</a>、<a
              href="https://roxx.co.jp/policy/privacy" target="_blank">個人情報保護方針</a>
          </p>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <el-checkbox v-model="isAgree"
              style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談を希望する</el-checkbox>
          </p>
        </div>
        <br />
        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended == false"
            style="background-color:#E3165C;border-color:#E3165C;font-size: 140%;"
            @click="$eventHub.$emit('send-roxx-consult');">　同意する　</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
            @click="closeDialog();">送信しました</el-button>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
          </p>
          <div class="text-center">
            <button type="button" class="el-button el-button--success" id="send-adtop-pdf"
              style="background-color:#0F9934;border-color:#0F9934;"
              onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
          </div>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
          </p>
          <div class="text-center">
            <button type="button" class="el-button el-button--success" id="send-adtop-pdf"
              style="background-color:#0F9934;border-color:#0F9934;"
              onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
          </div>
        </div>
      </div>

      <!--20260331追加 roxx_13, roxx_14, roxx_15, roxx_16 パーミッション追加-->
      <div class="setting" v-else-if="permissionType == 13 || permissionType == 14 || permissionType == 15 || permissionType == 16">
        <div class="setting-item">
          <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px;text-align: center;">ダウンロードが完了しました！！！</p>
          <p style="font-size: 16px; font-weight: bold;text-align: center;">今作成した履歴書をもとに<br
              class="sp">プロが好条件の勤め先をご紹介します！</p>

          <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
            <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);font-size: 1rem; font-weight: bold; margin-top: 10px;">
                <p style="font-size: 0.8rem; padding: 5px;">規約に同意して無料相談を希望する</p>
              </el-checkbox>
            </p>
          </div>

          <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
            :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
            @click="$eventHub.$emit('send-roxx-consult');">

            <p style="text-align: center; margin-bottom: 15px;">
              <img src="/static/renew3_img/rt/roxx_13-16_yagish_logo.png" alt="未経験転職に特化！" style="width: 90%;">
            </p>

            <p style="font-size: 16px; font-weight: bold; color: rgb(227, 22, 92);">
              <img src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                style="position: relative; height: 16px; top: -5px;">規約に同意して無料相談を希望する
            </p>
          </div>

          <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended == false"
              style="background: none; border: none; padding: 20px 0; margin-top: -20px; width: 100%;"
              @click="$eventHub.$emit('send-roxx-consult');"><span
                style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;">同意する</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
              @click="closeDialog();">送信しました</el-button>
          </div>

          <div class="text-center" v-else>
            <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isSended == false"
              style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
              @click="$eventHub.$emit('send-roxx-consult');">同意する</el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
              @click="closeDialog();">送信しました</el-button>
          </div>

          <div style="margin-top: 20px; text-align: center;">
            <p style="font-size: 10px;">
              Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
                target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
                target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
                target="_blank">プライバシーポリシー</a><br />

              Zキャリア エージェントの<a href="https://agent.zcareer.com/terms/" target="_blank">利用規約</a>、<a
                href="https://roxx.co.jp/policy/privacy" target="_blank">個人情報保護方針</a>を
              <br>確認してZキャリア エージェントに登録することになります。
            </p>

            <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って連絡が<br>いきますのでご確認お願いいたします！</p>

          </div>

        </div>
      </div>

      <!--20250604修正後-->
      <div class="setting" v-else>
        <div class="setting-item">
          <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px;text-align: center;">ダウンロードが完了しました！！！</p>
          <p style="font-size: 16px; font-weight: bold;text-align: center;">今作成した履歴書をもとに<br
              class="sp">プロが好条件の勤め先をご紹介します！</p>

          <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
            <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);font-size: 1rem; font-weight: bold; margin-top: 10px;">
                <p style="font-size: 0.8rem; padding: 5px;">規約に同意して無料相談を希望する</p>
              </el-checkbox>
            </p>
          </div>

          <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
            :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
            @click="$eventHub.$emit('send-roxx-consult');">

            <p style="text-align: center; margin-bottom: 15px;">
              <img src="/static/renew2_img/zcareer-roxx-yagish-logo.png" alt="キャリアシとヤギッシュ" style="width: 90%;">
            </p>

            <p style="font-size: 16px; font-weight: bold; color: rgb(227, 22, 92);">
              <img src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                style="position: relative; height: 16px; top: -5px;">規約に同意して無料相談を希望する
            </p>
          </div>

          <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended == false"
              style="background: none; border: none; padding: 20px 0; margin-top: -20px; width: 100%;"
              @click="$eventHub.$emit('send-roxx-consult');"><span
                style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;">同意する</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
              @click="closeDialog();">送信しました</el-button>
          </div>

          <div class="text-center" v-else>
            <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isSended == false"
              style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
              @click="$eventHub.$emit('send-roxx-consult');">同意する</el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
              @click="closeDialog();">送信しました</el-button>
          </div>

          <div style="margin-top: 20px; text-align: center;">
            <p style="font-size: 10px;">
              Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
                target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
                target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
                target="_blank">プライバシーポリシー</a><br />

              Zキャリア エージェントの<a href="https://agent.zcareer.com/terms/" target="_blank">利用規約</a>、<a
                href="https://roxx.co.jp/policy/privacy" target="_blank">個人情報保護方針</a>を
              <br>確認してZキャリア エージェントに登録することになります。
            </p>

            <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って連絡が<br>いきますのでご確認お願いいたします！</p>

          </div>

        </div>
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>

<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      clientId: 'roxx_api',
      username: '',
      baite_title: 'バイト',
      isAgree: true,
      inputEmail: '',
      gradeYear: '',
      foreignStudent: false,
      isRandom: true,
      basicData: {}
    }
  },
  created: function () {
    console.error('newgrade created')
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openRoxxDialog: function (id, html, email, permissionType, gradeYear, basicData, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.$modal.show('roxx-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType
      this.gradeYear = gradeYear
      this.basicData = basicData
      const app = this

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'roxx_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
      this.isSended = false
    },
    closeDialog: function () {
      this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
      this.$modal.hide('roxx-dialog')
      this.clearLocalStorageConfirmVisible = false
      // before-close の判定に影響しないように、送信状態のリセットは閉じた後に行う
      this.$nextTick(() => {
        this.isSended = false
      })
    },
    handleBeforeClose: function (event) {
      if (!this.isSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendRoxxConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }

      if (this.isSended) {
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'roxx_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('graduation_year', this.gradeYear + '年卒')
      if ((!this.$firebase.user.email && this.inputEmail) ||
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      if (this.formatid.includes('shokumukeirekisho')) {
        formData.append('data_source', 'work_history')
      } else {
        formData.append('data_source', 'resume')
      }
      formData.append('storage_data', JSON.stringify(this.basicData))
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendDataRoxx, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスに連絡が届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('roxx_dialog', `sendDataRoxx failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-roxx-consult', this.sendRoxxConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openRoxxDialog = wrapMittPopupHandler(this, 'openRoxxDialog')
    this.$emitter.on('open-roxx-dialog', this._mittGVPopup_openRoxxDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-roxx-consult', this.sendRoxxConsult)
    this.$emitter.off('open-roxx-dialog', this._mittGVPopup_openRoxxDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
